import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DataCount } from "../../redux/apiPath/api"; // Fix this import

export const getDataCounting = createAsyncThunk(
  "dataCount/getDataCounting",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await DataCount.dataCount(params);
      return response.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

const dataCountSlice = createSlice({
  name: "dataCount",
  initialState: {
    loading: false,
    error: null,
    pagination: { total: 0, page: 1, limit: 10, totalPages: 1 },
    statusCounts: { all: 0, active: 0, inactive: 0, deleted: 0 },
    search: "",
    status: "all",
    limit: 10,
    page: 1,
    success: false,
    dataCount: [],
  },

  reducers: {
    resetDataCountState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.dataCount = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDataCounting.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDataCounting.fulfilled, (state, action) => {
        state.loading = false;
        state.dataCount = action.payload.data;
        state.pagination = action.payload.pagination;
        state.statusCounts = action.payload.statusCounts;
      })
      .addCase(getDataCounting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetDataCountState } = dataCountSlice.actions;
export default dataCountSlice.reducer;
